var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3946 4.39736C13.2778 1.51087 10.4876 0.067627 7.6973 0.067627C4.90703 0.067627 2.11676 1.51087 0 4.39736C4.23351 10.1703 11.1611 10.1703 15.3946 4.39736ZM5.19568 1.99195C4.95513 2.42492 4.81081 2.90601 4.81081 3.43519C4.81081 5.02276 6.10973 6.32168 7.6973 6.32168C9.28486 6.32168 10.5838 5.02276 10.5838 3.43519C10.5838 2.90601 10.4395 2.42492 10.1989 1.99195C11.4016 2.47303 12.5562 3.29087 13.5665 4.39736C11.8827 6.27357 9.86216 7.28384 7.7454 7.28384C5.62865 7.28384 3.56 6.27357 1.87622 4.39736C2.83838 3.29087 3.99297 2.47303 5.19568 1.99195Z",
    fill: "#979797"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3fccd279f0d7a36f24046abc88947565.svg";
export { ForwardRef as ReactComponent };